/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WalkInRouteImport } from './routes/walk-in'
import { Route as KpisRouteImport } from './routes/kpis'
import { Route as FollowupsRouteImport } from './routes/followups'
import { Route as AuditRouteImport } from './routes/audit'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as SchoolsIndexRouteImport } from './routes/schools/index'
import { Route as SubscriptionsSubscriptionIdRouteImport } from './routes/subscriptions.$subscriptionId'
import { Route as SchoolsSchoolIdRouteImport } from './routes/schools/$schoolId'
import { Route as FamilyFamilyIdRouteImport } from './routes/family.$familyId'
import { Route as CampsCampIdRouteImport } from './routes/camps.$campId'
import { Route as ActivationConversationIdRouteImport } from './routes/activation.$conversationId'

const WalkInRoute = WalkInRouteImport.update({
  id: '/walk-in',
  path: '/walk-in',
  getParentRoute: () => rootRouteImport,
} as any)
const KpisRoute = KpisRouteImport.update({
  id: '/kpis',
  path: '/kpis',
  getParentRoute: () => rootRouteImport,
} as any)
const FollowupsRoute = FollowupsRouteImport.update({
  id: '/followups',
  path: '/followups',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditRoute = AuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const SchoolsIndexRoute = SchoolsIndexRouteImport.update({
  id: '/schools/',
  path: '/schools/',
  getParentRoute: () => rootRouteImport,
} as any)
const SubscriptionsSubscriptionIdRoute =
  SubscriptionsSubscriptionIdRouteImport.update({
    id: '/subscriptions/$subscriptionId',
    path: '/subscriptions/$subscriptionId',
    getParentRoute: () => rootRouteImport,
  } as any)
const SchoolsSchoolIdRoute = SchoolsSchoolIdRouteImport.update({
  id: '/schools/$schoolId',
  path: '/schools/$schoolId',
  getParentRoute: () => rootRouteImport,
} as any)
const FamilyFamilyIdRoute = FamilyFamilyIdRouteImport.update({
  id: '/family/$familyId',
  path: '/family/$familyId',
  getParentRoute: () => rootRouteImport,
} as any)
const CampsCampIdRoute = CampsCampIdRouteImport.update({
  id: '/camps/$campId',
  path: '/camps/$campId',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivationConversationIdRoute =
  ActivationConversationIdRouteImport.update({
    id: '/activation/$conversationId',
    path: '/activation/$conversationId',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/audit': typeof AuditRoute
  '/followups': typeof FollowupsRoute
  '/kpis': typeof KpisRoute
  '/walk-in': typeof WalkInRoute
  '/activation/$conversationId': typeof ActivationConversationIdRoute
  '/camps/$campId': typeof CampsCampIdRoute
  '/family/$familyId': typeof FamilyFamilyIdRoute
  '/schools/$schoolId': typeof SchoolsSchoolIdRoute
  '/subscriptions/$subscriptionId': typeof SubscriptionsSubscriptionIdRoute
  '/schools/': typeof SchoolsIndexRoute
  '/settings/': typeof SettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/audit': typeof AuditRoute
  '/followups': typeof FollowupsRoute
  '/kpis': typeof KpisRoute
  '/walk-in': typeof WalkInRoute
  '/activation/$conversationId': typeof ActivationConversationIdRoute
  '/camps/$campId': typeof CampsCampIdRoute
  '/family/$familyId': typeof FamilyFamilyIdRoute
  '/schools/$schoolId': typeof SchoolsSchoolIdRoute
  '/subscriptions/$subscriptionId': typeof SubscriptionsSubscriptionIdRoute
  '/schools': typeof SchoolsIndexRoute
  '/settings': typeof SettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/audit': typeof AuditRoute
  '/followups': typeof FollowupsRoute
  '/kpis': typeof KpisRoute
  '/walk-in': typeof WalkInRoute
  '/activation/$conversationId': typeof ActivationConversationIdRoute
  '/camps/$campId': typeof CampsCampIdRoute
  '/family/$familyId': typeof FamilyFamilyIdRoute
  '/schools/$schoolId': typeof SchoolsSchoolIdRoute
  '/subscriptions/$subscriptionId': typeof SubscriptionsSubscriptionIdRoute
  '/schools/': typeof SchoolsIndexRoute
  '/settings/': typeof SettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/audit'
    | '/followups'
    | '/kpis'
    | '/walk-in'
    | '/activation/$conversationId'
    | '/camps/$campId'
    | '/family/$familyId'
    | '/schools/$schoolId'
    | '/subscriptions/$subscriptionId'
    | '/schools/'
    | '/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/audit'
    | '/followups'
    | '/kpis'
    | '/walk-in'
    | '/activation/$conversationId'
    | '/camps/$campId'
    | '/family/$familyId'
    | '/schools/$schoolId'
    | '/subscriptions/$subscriptionId'
    | '/schools'
    | '/settings'
  id:
    | '__root__'
    | '/'
    | '/audit'
    | '/followups'
    | '/kpis'
    | '/walk-in'
    | '/activation/$conversationId'
    | '/camps/$campId'
    | '/family/$familyId'
    | '/schools/$schoolId'
    | '/subscriptions/$subscriptionId'
    | '/schools/'
    | '/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuditRoute: typeof AuditRoute
  FollowupsRoute: typeof FollowupsRoute
  KpisRoute: typeof KpisRoute
  WalkInRoute: typeof WalkInRoute
  ActivationConversationIdRoute: typeof ActivationConversationIdRoute
  CampsCampIdRoute: typeof CampsCampIdRoute
  FamilyFamilyIdRoute: typeof FamilyFamilyIdRoute
  SchoolsSchoolIdRoute: typeof SchoolsSchoolIdRoute
  SubscriptionsSubscriptionIdRoute: typeof SubscriptionsSubscriptionIdRoute
  SchoolsIndexRoute: typeof SchoolsIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/walk-in': {
      id: '/walk-in'
      path: '/walk-in'
      fullPath: '/walk-in'
      preLoaderRoute: typeof WalkInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kpis': {
      id: '/kpis'
      path: '/kpis'
      fullPath: '/kpis'
      preLoaderRoute: typeof KpisRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/followups': {
      id: '/followups'
      path: '/followups'
      fullPath: '/followups'
      preLoaderRoute: typeof FollowupsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit': {
      id: '/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/schools/': {
      id: '/schools/'
      path: '/schools'
      fullPath: '/schools/'
      preLoaderRoute: typeof SchoolsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscriptions/$subscriptionId': {
      id: '/subscriptions/$subscriptionId'
      path: '/subscriptions/$subscriptionId'
      fullPath: '/subscriptions/$subscriptionId'
      preLoaderRoute: typeof SubscriptionsSubscriptionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/schools/$schoolId': {
      id: '/schools/$schoolId'
      path: '/schools/$schoolId'
      fullPath: '/schools/$schoolId'
      preLoaderRoute: typeof SchoolsSchoolIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/family/$familyId': {
      id: '/family/$familyId'
      path: '/family/$familyId'
      fullPath: '/family/$familyId'
      preLoaderRoute: typeof FamilyFamilyIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/camps/$campId': {
      id: '/camps/$campId'
      path: '/camps/$campId'
      fullPath: '/camps/$campId'
      preLoaderRoute: typeof CampsCampIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activation/$conversationId': {
      id: '/activation/$conversationId'
      path: '/activation/$conversationId'
      fullPath: '/activation/$conversationId'
      preLoaderRoute: typeof ActivationConversationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuditRoute: AuditRoute,
  FollowupsRoute: FollowupsRoute,
  KpisRoute: KpisRoute,
  WalkInRoute: WalkInRoute,
  ActivationConversationIdRoute: ActivationConversationIdRoute,
  CampsCampIdRoute: CampsCampIdRoute,
  FamilyFamilyIdRoute: FamilyFamilyIdRoute,
  SchoolsSchoolIdRoute: SchoolsSchoolIdRoute,
  SubscriptionsSubscriptionIdRoute: SubscriptionsSubscriptionIdRoute,
  SchoolsIndexRoute: SchoolsIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
